import type { RouteRecordRaw } from 'vue-router';

export const payRoutes: Array<RouteRecordRaw> = [
  {
    path: '/pay',
    name: 'pay',
    redirect: '/pay/list',
    component: () => import('pages/central/pay/McPayment.vue'),
    meta: {
      title: 'Payments',
    },
    children: [
      {
        path: 'process/new',
        name: 'payProcessingNew',
        component: () => import('pages/central/pay/PaymentProcessingNew.vue'),
        meta: {
          title: 'New Payment Processing [Testing]',
          requiresAuth: true,
        },
      },
      {
        path: 'process',
        name: 'payProcessing',
        component: () => import('pages/central/pay/PaymentProcessing.vue'),
        meta: {
          title: 'Payment Processing [Testing]',
          requiresAuth: true,
        },
      },
      {
        path: 'checkout',
        name: 'payCheckout',
        component: () => import('pages/central/pay/process/PaymentCheckout.vue'),
        meta: {
          title: 'Payment Checkout',
          requiresAuth: true,
        },
      },
      {
        path: 'a/checkout/:sessionId?/:orderTitle?/:orderId?/:orderAmount?/:redirectPage?/:redirectPath?/:successPage?/:previousPage?/:refererPage?/:currency?',
        name: 'payCheckout1',
        component: () => import('pages/central/pay/process/PaymentCheckout.vue'),
        meta: {
          title: 'Payment Checkout',
          requiresAuth: true,
        },
      },
      {
        path: 'setup/intent',
        name: 'setupPayIntent',
        component: () => import('pages/central/pay/process/SetupIntent.vue'),
        meta: {
          title: 'Setup Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'a/setup/intent/:setup_intent?/:setup_intent_client_secret?/:sessionId?/:orderTitle?/:orderId?/:orderAmount?/:redirectPage?/:redirectPath?/:successPage?/:previousPage?/:refererPage?/:currency?',
        name: 'setupPayIntent1',
        component: () => import('pages/central/pay/process/SetupIntent.vue'),
        meta: {
          title: 'Setup Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'intent',
        name: 'payIntent',
        component: () => import('pages/central/pay/process/PaymentIntent.vue'),
        meta: {
          title: 'Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'a/intent/:payment_intent_client_secret?/:sessionId?/:orderTitle?/:orderId?/:orderAmount?/:redirectPage?/:redirectPath?/:successPage?/:previousPage?/:refererPage?/:currency?',
        name: 'payIntent1',
        component: () => import('pages/central/pay/process/PaymentIntent.vue'),
        meta: {
          title: 'Payment Intent',
          requiresAuth: true,
        },
      },
      {
        path: 'list',
        name: 'payList',
        component: () => import('pages/central/pay/PaymentList.vue'),
        meta: {
          title: 'Payments List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail',
        name: 'payDetail',
        component: () => import('pages/central/pay/PaymentDetail.vue'),
        meta: {
          title: 'Payment Details',
          requiresAuth: true,
        },
      },
      {
        path: 'view',
        name: 'payView',
        component: () => import('pages/central/pay/PaymentView.vue'),
        meta: {
          title: 'Payment View',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'payNew',
        component: () => import('pages/central/pay/PaymentNew.vue'),
        meta: {
          title: 'New Payment',
          requiresAuth: true,
        },
      },
      {
        path: 'provider',
        name: 'payProvider',
        redirect: '/pay/provider/list',
        component: () => import('pages/central/pay/provider/PaymentProvider.vue'),
        meta: {
          title: 'Payment Providers',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'payProviderList',
            component: () => import('pages/central/pay/provider/PaymentProviderList.vue'),
            meta: {
              title: 'Payment Providers List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'payProviderDetail',
            component: () => import('pages/central/pay/provider/PaymentProviderDetail.vue'),
            meta: {
              title: 'Payment Provider Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'payProviderNew',
            component: () => import('pages/central/pay/provider/PaymentProviderNew.vue'),
            meta: {
              title: 'New Payment Provider',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'card',
        name: 'payCard',
        redirect: '/pay/card/list',
        component: () => import('pages/central/pay/card/PaymentCard.vue'),
        meta: {
          title: 'Payment Cards',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'payCardList',
            component: () => import('pages/central/pay/card/PaymentCardList.vue'),
            meta: {
              title: 'Payment Cards List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'payCardDetail',
            component: () => import('pages/central/pay/card/PaymentCardDetail.vue'),
            meta: {
              title: 'Payment Card Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'payCardNew',
            component: () => import('pages/central/pay/card/PaymentCardNew.vue'),
            meta: {
              title: 'New Payment Card',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'customer',
        name: 'payCustomer',
        redirect: '/pay/customer/list',
        component: () => import('pages/central/pay/customer/PaymentCustomer.vue'),
        meta: {
          title: 'Payment Customers',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'payCustomerList',
            component: () => import('pages/central/pay/customer/PaymentCustomerList.vue'),
            meta: {
              title: 'Payment Customers List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'payCustomerDetail',
            component: () => import('pages/central/pay/customer/PaymentCustomerDetail.vue'),
            meta: {
              title: 'Payment Customer Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'payCustomerNew',
            component: () => import('pages/central/pay/customer/PaymentCustomerNew.vue'),
            meta: {
              title: 'New Payment Customer',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'method',
        name: 'payMethod',
        redirect: '/pay/method/list',
        component: () => import('pages/central/pay/method/PaymentMethod.vue'),
        meta: {
          title: 'Payment Methods',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'payMethodList',
            component: () => import('pages/central/pay/method/PaymentMethodList.vue'),
            meta: {
              title: 'Payment Methods List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'payMethodDetail',
            component: () => import('pages/central/pay/method/PaymentMethodDetail.vue'),
            meta: {
              title: 'Payment Method Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'payMethodNew',
            component: () => import('pages/central/pay/method/PaymentMethodNew.vue'),
            meta: {
              title: 'New Payment Method',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'refund',
        name: 'payRefund',
        redirect: '/pay/refund/list',
        component: () => import('pages/central/pay/refund/PaymentRefund.vue'),
        meta: {
          title: 'Payment Refunds',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'payRefundList',
            component: () => import('pages/central/pay/refund/PaymentRefundList.vue'),
            meta: {
              title: 'Payment Refunds List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail',
            name: 'payRefundDetail',
            component: () => import('pages/central/pay/refund/PaymentRefundDetail.vue'),
            meta: {
              title: 'Payment Refund Details',
              requiresAuth: true,
            },
          },
          {
            path: 'a/detail/:itemId?/:reason?/:status?/:refundAppFee?/:payIntent?/:orderAmount?/:refundableAmount?/:orderId?/:paymentCategory?/:paymentStatus?',
            name: 'payRefundDetail1',
            component: () => import('pages/central/pay/refund/PaymentRefundDetail.vue'),
            meta: {
              title: 'Payment Refund Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'payRefundNew',
            component: () => import('pages/central/pay/refund/PaymentRefundNew.vue'),
            meta: {
              title: 'New Payment Refund',
              requiresAuth: true,
            },
          },
        ],
      },
      {
        path: 'sub',
        name: 'paySub',
        redirect: '/pay/sub/list',
        component: () => import('pages/central/pay/sub/PaymentSub.vue'),
        meta: {
          title: 'Payment Subscriptions',
          requiresAuth: true,
        },
        children: [
          {
            path: 'list',
            name: 'paySubList',
            component: () => import('pages/central/pay/sub/PaymentSubList.vue'),
            meta: {
              title: 'Payment Subscriptions List',
              requiresAuth: true,
            },
          },
          {
            path: 'detail/:itemId?',
            name: 'paySubDetail',
            component: () => import('pages/central/pay/sub/PaymentSubDetail.vue'),
            meta: {
              title: 'Payment Subscription Details',
              requiresAuth: true,
            },
          },
          {
            path: 'new',
            name: 'paySubNew',
            component: () => import('pages/central/pay/sub/PaymentSubNew.vue'),
            meta: {
              title: 'New Payment Subscription',
              requiresAuth: true,
            },
          },
        ],
      },
    ],
  },
];
